<div class="ask-share-us-form-modal-container">
    <div id="ask-share-us-form-modal">
        <div class="modal-header">
            <h5 class="modal-title" [translate]="'ask_share_us_form_modal.title'"></h5>
        </div>

        <div class="modal-body" #shareModalForm>This is the sharing!</div>

        <div class="modal-body" #donateModalForm>This is the Donation</div>

        <div class="modal-footer">
            <button-control
                buttonType="button"
                themeColor="secondary"
                [buttonText]="'common.close'"
                (onClick)="close()">
            </button-control>
        </div>
    </div>
</div>
